import { BreakPoint } from '@bucketplace/design-system';
import { GridItemProps } from '@bucketplace/design-system/bds';

export type VerticalAlign = 'flex-start' | 'center' | 'flex-end';
export type GridColumn = GridItemProps['column'];

export interface GridData {
  /** 열 개수 */
  column: number;
  /** 비율 */
  columnRatio: number[];
  /** 간격 */
  gap: number;
  /** 세로축 정렬 */
  verticalAlign: VerticalAlign;
}

export const BREAK_POINT_OPTIONS: {
  value: BreakPoint,
  label: string,
}[] = [
  { value: 'mobile', label: '모바일' },
  { value: 'tablet', label: '태블릿' },
  { value: 'laptop', label: '랩탑' },
  { value: 'desktop', label: '데스크탑' },
];

export const INITIAL_GRID_DATA: GridData = {
  column: 2,
  columnRatio: [1, 1],
  gap: 10,
  verticalAlign: 'flex-start',
};
